export default "__VITE_ASSET___XTfUQAN__"